module.exports = __webpack_public_path__ + "static/media/ProdigalTiger_jacket.f3f46440.jpg";